import { CompanyBlock, SHEET_CSS } from './QuotationSheet';

const yen = (n) => (n == null ? '' : '¥' + Number(n).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' }));
const jd = (iso) => (iso ? String(iso).slice(0, 10).replaceAll('-', '/') : '');

// 領収書 A4 print sheet — mkt_documents (doc_type: receipt) のスナップショットのみ描画
export default function ReceiptSheet({ doc }) {
  if (!doc) return null;
  const s = doc.snapshot || {};
  const c = s.customer || {};
  const co = s.company || {};
  const [y, m] = (s.month || '').split('-');

  return (
    <>
      <style>{SHEET_CSS}</style>
      <div className="mkt-sheet" data-testid="mkt-receipt-sheet">
        <div className="meta">
          <div>領収書番号: <b>{doc.doc_no}</b></div>
          <div>発行日: {jd(doc.issued_at)}</div>
        </div>
        <h1 className="title">領 収 書</h1>
        <div className="accent" />

        <div className="parties">
          <div className="cust">
            <div className="cust-name">{c.name || ''}　{c.honorific || '御中'}</div>
            {(c.zip || c.address) && <div style={{ fontSize: '8.5pt', color: '#3f3f46' }}>{c.zip ? `〒${String(c.zip).replace('〒', '')}　` : ''}{c.address || ''}</div>}
            <div className="total-band" style={{ marginTop: '8mm' }}>
              <span className="lbl">領収金額</span>
              <span className="val" data-testid="mkt-receipt-total">{yen(s.total)}</span>
              <span className="tax-note">（税込）</span>
            </div>
            <div className="info">
              <div className="kv"><span className="k">領収日</span><span>{jd(s.paid_at)}</span></div>
              {s.method_label && <div className="kv"><span className="k">お支払方法</span><span>{s.method_label}</span></div>}
              <div className="kv"><span className="k">内訳</span><span>税抜 {yen(s.subtotal)} ／ 消費税 {yen(s.tax)}</span></div>
            </div>
          </div>
          <div>
            <div style={{
              border: '1px solid #a1a1aa', width: '20mm', height: '20mm', marginLeft: 'auto',
              marginBottom: '3mm', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '7.5pt', color: '#a1a1aa', textAlign: 'center', lineHeight: 1.4,
            }}>収入<br />印紙</div>
            <CompanyBlock s={s} co={co} />
          </div>
        </div>

        <div className="box" style={{ marginTop: '8mm' }}>
          <div className="box-lbl">但し書き</div>
          <div>
            但し、{y}年{Number(m)}月度 締め請求分（請求書 {s.invoice_doc_no}）として、上記金額正に領収いたしました。
          </div>
        </div>

        <div className="foot">
          <span>発行者: {doc.issued_by}</span>
        </div>
      </div>
    </>
  );
}
